import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, Subscription, forkJoin, interval } from 'rxjs';
import { RoleModel } from './Models/role.model';
import { RoomModel } from './Models/room.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompanyModel } from './Models/company.model';
import { BillingCompanyModel } from './Models/billingcompany.model';
import { CapchaInformation, LoggedInUser } from './Models/loggedinuserobj.model';
import { Router } from '@angular/router';
import { SiteloaderComponent } from './siteloader/siteloader.component';
import { UserInfoModel } from './Models/userinfo.model';
import { Initial_loaderComponent } from './initial_loader/initial_loader.component';
import { map } from 'rxjs/internal/operators/map';
import { environment } from 'environments/environment';
import * as signalR from '@microsoft/signalr';
import { Message } from '_debugger';
import { ThemeInfoModel } from './Models/theme.model';
import { WebReportConfigurationModel, webstorageConfigModel } from './Models/webreportconfig.model';
import { shareReplay } from 'rxjs/operators';
//import { LanguageService } from 'app/shared/language.service';
//import * as Config from 'assets/config.json'
@Injectable({
  providedIn: 'root'
})

export class AuthService {

  users: UserInfoModel[] = [];
  //userobj: any = [];
  FinYears: any[] = [];
  Roles: RoleModel[] = [];
  Rooms: RoomModel[] = [];
  Branches: any[] = [];
  Companies: CompanyModel[] = [];
  BillingCompanies: BillingCompanyModel[] = [];
  webreportConfig: WebReportConfigurationModel[] = [];
  smsConfigdata: boolean = false;
  Loggeduser: LoggedInUser = {};
  logincapcha: CapchaInformation = {}
  activatedusers: number;
  oldpasswordtyped: string;
  newpassword: string;
  confirmpassword: string;
  //userid: number;
  // selectedbranch: number;
  // selectedbranchname: string;
  selectedrole: number;
  selectedcompany: number;
  selectedbillingcompany: number;
  masterdata: any = {};

  selectedcompanyname: string;
  displayFinYear: string;
  showloginbox = true;
  showcompanybox = false;
  showchangepasswordbox = false;
  showspinner = false;
  showforgotpasswordbox = false;
  public is_live: string;
  public baseUrl: string;
  public newbaseUrl: string;
  public sidebarimagelive: boolean = false;
  public homeimagelive: boolean = false;
  public sidebarimage: boolean = false;
  public homeimage: boolean = false;
  public rolecheckdisable: boolean = false;
  public logoELiTitle: boolean = false;
  public wasareportTitle: boolean = false;
  public logoRAJASTitle: boolean = false;
  public getuserId: number;
  public checkThemeStatus: number;
  public checkThemetype: number;
  public captchadata: boolean = false;
  public customeThemeAray: any = [];

  public defaultThemeAray: any = [];
  public languageMaster: any = [];
  public pklanguageid: number = 1;
  private message$: Subject<Message>;
  private connection: signalR.HubConnection;

  public checksingalR: boolean = true;
  public tourGuideDashboard: boolean = true;
  timeInterval;
  fontsize: any = [];
  fontFamily: any = [];
  themedataobj: ThemeInfoModel = {};

  public bodybgobj: any = {};
  public bodytxtobj: any = {};
  public bodyfontsizeobj: any = {};
  public bodyfontfamilyobj: any = {};
  public headerbgobj: any = {};
  public headertxtobj: any = {};
  public pagebgobj: any = {};
  public pagetxtobj: any = {};
  public pagefontsizeobj: any = {};
  public pagefontfamilyobj: any = {};
  public pagebtnobj: any = {};
  public pagebtn2obj: any = {};
  public inputbgobj: any = {};
  public inputtxtobj: any = {};
  public tableheadingbgobj: any = {};
  public tableheadingtxtobj: any = {};
  public tabledatabgobj: any = {};
  public tabledatatxtobj: any = {};
  public tableheadingfontsizeobj: any = {};
  public tabledatafontsizeobj: any = {};
  public iconbgobj: any = {};
  public icontxtobj: any = {};
  public sidebarbgobj: any = {};
  public sidebartxtobj: any = {};
  public desiableTheme: boolean;
  public selectedTheme: any
  public bodybgtransId: number;
  // public categories: CategoryModel[] = [];
  getServerDate: any;
  public checkfirsttimeload: boolean = false;
  public webstorageConfigobj: webstorageConfigModel = {};
  rememberme: boolean = true;
  serverTime: any;
  timeParts: any;
  localDate: any;
  webconfigurl: any;
  public storevisitdata: Observable<any[]>;
  public langcontent = new BehaviorSubject<string>('0');
  public langshare = this.langcontent.asObservable();
  public validationMsg: any;
  public appointmentMsg: any;
  public LoginvalidationMsg: any;
  public RemarkvalidationMsg: any;
  public loginclientlogo: any;
  public nabhlogo: any;
  public healthcare: any;
  public collapselogo: any;
  public leftbottomlogo: any;
  public leftbottomlogosm: any;
  public moduleTypearray: any = [];
  DynamicLinks: any;
  SameUserLogin: boolean = false;
  LoginsubSpecialityName = 0;
  areaArray: any;
  public themenApiunsub: any;
  constructor(private http: HttpClient,
    private snackBar: MatSnackBar, private router: Router, private dialog: MatDialog) {

    this.loginclientlogo = 'assets/img/login-client-logo.png' + "?" + Math.floor(Math.random() * 100) + 1;
    this.nabhlogo = 'assets/img/nabh-logo.png' + "?" + Math.floor(Math.random() * 100) + 1;
    this.healthcare = 'assets/img/healthcare.png' + "?" + Math.floor(Math.random() * 100) + 1;
    this.collapselogo = 'assets/img/collapse-logo.svg' + "?" + Math.floor(Math.random() * 100) + 1;
    this.leftbottomlogo = 'assets/img/left-bottom-logo.png' + "?" + Math.floor(Math.random() * 100) + 1;
    this.leftbottomlogosm = 'assets/img/left-bottom-logo-sm.png' + "?" + Math.floor(Math.random() * 100) + 1;
    // this.baseUrl =environment.ENV_baseUrl webconfigurl;
    this.newbaseUrl = environment.ENV_newbaseUrl;
    this.sidebarimage = environment.sidebarimage;
    this.homeimage = environment.homeimage;
    this.logoELiTitle = environment.logoELiTitle;
    this.sidebarimagelive = environment.sidebarimagelive;
    this.homeimagelive = environment.homeimagelive;
    this.logoRAJASTitle = environment.logoRAJASTitle;
    this.wasareportTitle = environment.wasa1reportTitle;
    this.message$ = new Subject<Message>();
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(environment.hubUrl)
      .build();

    this.customeThemeAray = [];
    this.defaultThemeAray = [];
    this.fontsize = ['9px', '10px', '11px', '12px', '13px', '14px', '15px', '16px', '17px', '18px', '19px', '20px', '21px', '22px']
    this.fontFamily = ['inherit ,Times', 'Times,serif', 'Lato,system-ui', 'inherit,serif', 'serif,system-ui', 'inherit,serif,system-ui']
  }


  public connect() {
    this.checksingalR == true
    this.connection.start().catch(err => console.log(err));
    this.connection.on('SendMessage', (message) => {
      if (this.checksingalR == true) {
        this.message$.next(message);
        this.checksingalR = false;
      }
    });


  }

  public getMessage(): Observable<Message> {
    return this.message$;
  }

  public disconnect() {
    this.connection.stop();
  }


  // updateroom() {
  // old url
  //   return this.http.put<any>(this.baseUrl + "UserMaster/UpdateRoom/" + this.Loggeduser.userid + "/" + this.Loggeduser.roomid, [])
  // }

  updateroom() {
    let payload = {
      "roomNo": this.Loggeduser.room, "LoginRoomID": this.Loggeduser.roomid
    }
    return this.http.post<any>(this.newbaseUrl + "UserMaster/UpdateRoom", payload);
  }

  getallusers() {
    this.http.get<any>(this.newbaseUrl + "UserMaster/GetUserAll").subscribe(
      data => this.success_all_users(data), err => this.failed_all_users(err)
    )
  }
  public getcopySubscription: Subscription;
  getcheckSIngal() {
    if (this.DynamicLinks?.requiredSignal == 'Y' || this.DynamicLinks?.requiredSignal == 'y') {
      this.getcopySubscription = this.http.get<any>(this.newbaseUrl + "VisitMaster/GetCopy").subscribe(
        data => this.success_allsingal(data), err => this.failed_all_users(err)
      )
    }
  }
  success_allsingal(data) {
    // console.log('star signalR')

  }

  failed_all_users(err) {
    // console.log("all users api failed " + err);
    // console.log('failed signalR')
  }
  getwebConfigAPI() {
    this.http.get<any>(this.newbaseUrl + "Configuration/GetWebReportPrintMasterById/0").subscribe(
      data => this.success_webconfigreport(data), err => this.failed_all_users(err)
    )
  }
  getsmsConfigAPI(branchid) {
    // this.http.get<any>(this.newbaseUrl + "SendSMS/GetSmsConfigurationByBranchIdByTranId/" + branchid + "/0").subscribe(
    //   data => this.success_smsconfigreport(data), err => this.failed_all_users(err)
    // )
    this.http.get<any>(this.newbaseUrl + "Configuration/ChkSmsConfiguration/" + branchid).subscribe(
      data => this.success_smsconfigreport(data), err => this.failed_all_users(err)
    )
  }
  success_smsconfigreport(data) {
    this.smsConfigdata = data;
  }
  success_webconfigreport(data) {
    this.webreportConfig = [];
    this.webreportConfig = data;

  }

  success_all_users(data) {
    this.users = data;
    if (localStorage.length != 0 && this.rememberme == true) {
      this.rememberme = true;
      this.Loggeduser.username = sessionStorage.getItem('userName');
      // let getuserpsw = atob(localStorage.password)
      // this.Loggeduser.password = getuserpsw;
    } else {
      this.rememberme = false;
    }
    // console.log("all users api success " + this.users);
    //this.dialog.closeAll();
  }





  open_initial_loader_Dialog(): void {

    const dialogRef = this.dialog.open(Initial_loaderComponent, {
      width: '400px',
      data: {
        //  id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

      //pid = result;
    });

  }
  getcolumnwidthandcaption() {
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetOpdConfig/" + this.Loggeduser.branchid + '/' + this.Loggeduser.specialityId)
  }

  setselectedColoums(obj) {
    return this.http.post<any>(this.newbaseUrl + "VisitMaster/UpdateOPDManagerConfig", obj);
  }
  // this.setdefault_remark_values();
  GetNameByType(parameter) {
    return this.http.get<any>(this.newbaseUrl + "Common/GetModuleSpeciality/" + parameter).subscribe((x: any) => {
      this.moduleTypearray = [];
      this.moduleTypearray = x;
    }, err => {

    });
  }


  //  }

  open_loader_Dialog(): void {

    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: '300px',
      panelClass: 'site-loader',
      data: {
        //  id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed');
      //pid = result;
    });
  }
  getLanguageMaster() {
    this.http.get<any>(this.newbaseUrl + "Common/GetLanguageMaster/0").
      subscribe(data => this.successlanguage(data), err => this.failedlanguage(err));
  }
  successlanguage(data) {
    this.languageMaster = [];
    if (data.length > 0) {
      this.languageMaster = data.filter(item => (item.applicationTypeId == 0 || item.applicationTypeId == 2) && item.isActive == true);
      this.langcontent.next('2');
    }
  }
  failedlanguage(err) {

  }
  getcompanies() {
    this.http.get<any>(this.newbaseUrl + "CompanyMaster/GetCompany").
      subscribe(data => this.successcompanies(data), err => this.failedcompanies(err));
  }

  getbillingcompanies() {
    this.http.get<any>(this.newbaseUrl + "BillingCompany").
      subscribe(data => this.successbillcompanies(data), err => this.failedbillcompanies(err));
  }


  getallbranches() {
    // return this.http.get<any>(this.newbaseUrl + "branchMaster/getBranchAll").
    return this.http.get<any>(this.newbaseUrl + "BranchMaster/GetBranchByUserId/" + 0).
      subscribe(data => this.successbranches(data),
        err => this.failedbranches(err));
  }
  insertthemedata(data) {
    // console.log(this.newbaseUrl + "Common/InsertTheme");
    return this.http.post<any>(this.newbaseUrl + "Common/InsertTheme", data);
  }

  getcustomthemedata(id: any) {
    this.themenApiunsub = this.http.get<any>(this.newbaseUrl + "Common/Theme/custom/" + id).subscribe(data =>
      this.customethemeSuccsessfully(data), err => this.customethemefailed(err));
  }
  customethemeSuccsessfully(data: any) {

    this.customeThemeAray = data;
    if (this.customeThemeAray.length > 0) {
      let getlanguge = this.customeThemeAray.filter(item => item.tag == 'Language' && item.isActive == true);
      if (getlanguge.length > 0) {
        this.langcontent.next(getlanguge[0].value);
      }
      this.setcusthemeforme();
    }
    else {
      this.setdefailthem();

    }

  }
  customethemefailed(err: any) {

  }
  // LoginUser(){
  //   return  this.http.get<any>(this.newbaseUrl + "UserMaster/CompanyObject/" +
  //   this.Loggeduser.username + "/" + this.Loggeduser.password + '/' + 0);
  // }
  // login() {
  //   this.open_loader_Dialog();
  //   this.LoginUser().subscribe(data => this.successlogin(data), err => this.failedlogin(err));

  // }

  LoginUser(payload: any) {
    return this.http.post<any>(this.newbaseUrl + "UserMaster/CompanyObject", payload);
  }
  login() {

    var payload;
    this.open_loader_Dialog();
    if (this.captchadata) {
      if (this.logincapcha.CAns) {
        payload = {
          "Nam": this.Loggeduser.username,
          "Pas": this.Loggeduser.password,
          "CI": this.logincapcha.CI,
          "CAns": this.logincapcha.CAns
        }
      } else {
        this.dialog.closeAll();
        return this.openSnackBar("Please enter captcha verification code", this.LoginvalidationMsg['Ok']);
      }

    } else {
      payload = {
        "Nam": this.Loggeduser.username,
        "Pas": this.Loggeduser.password
      }
    }

    this.LoginUser(payload).pipe(shareReplay(1)).subscribe(data => this.successlogin(data), err => this.failedlogin(err));

  }

  // getUserDetails(id: any) {
  //   return this.http.get<any>(this.newbaseUrl + "UserMaster/GetUserByUserIdWithMobileNoAndEmail/" + id)
  // }

  userMobileOTP(data: any) {
    return this.http.post<any>(this.newbaseUrl + "SendSMS/SendMessage", data)
  }

  userEmailOTP(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Email/Send", data)
  }

  vrifypwd(name: any, opt: any) {
    return this.http.get<any>(this.newbaseUrl + "UserMaster/VerifyOTP/" +
      name + "/" + opt + "/V");
  }
  // userpswSave(Userid: number, Password: string) {
  //   return this.http.get<any>(this.newbaseUrl + "UserMaster/Change/" +
  //     Userid + "/" + Password);
  // }

  getrooms() {
    //  this.http.get<any>(this.newbaseUrl + "HospitalRoom").
    if (this.Loggeduser.branchid > 0) {
      this.http.get<any>(this.newbaseUrl + "Common/GetHospitalRoomByBranchId/" + this.Loggeduser.branchid).

        subscribe(data => this.successrooms(data), err => this.failedrooms(err));
    } else {
      this.Rooms = [];
    }

  }

  getroles() {
    this.http.get<any>(this.newbaseUrl + "UserMaster/GetRoles").
      subscribe(data => this.successroles(data), err => this.failedroles(err));
    // this.http.get<any>(this.newbaseUrl + "UserMaster/GetRoles" +
    //   this.Loggeduser.username + "/" + this.Loggeduser.password + "/" + 0).
    //   subscribe(data => this.successroles(data), err => this.failedroles(err));
  }
  GetAreaData() {
    this.http.get<any>(this.newbaseUrl + "UserMaster/GetUserSubSpecialityByUserId").subscribe(item => {
      this.areaArray = item;
      //  console.log(this.areaArray)
      // this.AreaControll();
    })
  }
  //test api
  getRolesData(): Observable<RoleModel[]> {
    return this.http.get(this.newbaseUrl + "UserMaster/GetRoles/" +
      this.Loggeduser.username + "/" + this.Loggeduser.password + "/" + 0).pipe(map((res: any) => {
        return <RoleModel[]>res;
      }));
  }

  getfinyear() {
    return this.http.get<any>(this.newbaseUrl + "FinYearMaster")
      .subscribe(data => this.successfinyear(data),
        err => this.failedfinyear(err));
  }


  getdefaulttheme() {
    this.http.get<any>(this.newbaseUrl + 'Common/Theme/Default/1')
      .subscribe(data => this.defailtthemeSuccssfully(data), err => this.defailtthemefailed(err))
  }


  defailtthemeSuccssfully(data: any) {
    this.defaultThemeAray = data;
    this.setdefailthem();
  }

  defailtthemefailed(err: any) {

  }



  getactiveusers() {
    //http://49.50.108.154:7575/api/UserMaster/ActiveUser
    return this.http.get<any>(this.newbaseUrl + "UserMaster/ActiveUser")
      .subscribe(data => this.successactiveusers(data),
        err => this.failedactiveusers(err));
  }

  changepassword(payload: any): Observable<any> {
    return this.http.post<any>(this.newbaseUrl + "UserMaster/PwdChangeOTP",
      payload);

  }
  changepasswordinner(payload: any): Observable<any> {
    return this.http.post<any>(this.newbaseUrl + "UserMaster/PwdChange", payload);
  }

  successbillcompanies(data) {
    this.BillingCompanies = data;
    this.BillingCompanies = this.BillingCompanies.filter(c => c.isActive == true);

    this.selectedbillingcompany = 1;
    this.Loggeduser.billingcompanyid = this.selectedbillingcompany;
  }
  failedbillcompanies(err) {

  }
  successcompanies(data) {

    this.Companies = data;
    this.Companies = this.Companies.filter(c => c.isActive == true);
    this.selectedcompany = 1;
    this.Loggeduser.companyid = this.selectedcompany;

  }

  failedcompanies(err) {

  }

  successroles(data) {
    this.Roles = data;
    if (this.Roles.length == 1) {
      this.rolecheckdisable = true;
    } else {
      this.rolecheckdisable = false;
    }
    //  this.selectedrole = 9;

    //this.Loggeduser.roletypeid = this.selectedrole;
  }
  failedroles(err) {

  }

  successrooms(data) {
    this.Rooms = data.filter(da => da.isActive == true);
    if (this.Rooms.length > 0) {
      let checkroomno = this.Rooms.filter(item => String(item.roomNo).toLowerCase() == String(this.Loggeduser.room).toLowerCase());
      if (checkroomno.length > 0) {
        this.Loggeduser.roomid = checkroomno[0].pkRoomId;
      } else {
        this.Loggeduser.roomid = 0;
        this.Loggeduser.room = '0';
      }
    }



  }
  failedrooms(err) {

  }


  refreshgeneratecapta() {
    this.GetgenerateCaptcha().subscribe((data: any) => {
      if (data) {
        this.logincapcha = {};
        this.logincapcha.CI = data.ci;
        this.logincapcha.CF = `data:image/png;base64,${data.cf}`;
        this.logincapcha.CAns = null;
      }
    })
  }
  successlogin(data: any) {
    this.dialog.closeAll();
    if (data.id == -10) {

      return this.openSnackBar("Please Enter valid User Name and Password", this.LoginvalidationMsg['Ok']);
    } else if (data.id == -102) {

      if (data.message) {
        this.captchadata = true;
        this.logincapcha = {};
        this.logincapcha = JSON.parse(data.message);
        this.logincapcha.CF = `data:image/png;base64,${this.logincapcha.CF}`;
        this.logincapcha.CAns = null;
      } else {
        this.captchadata = true;
        this.refreshgeneratecapta();
      }
      return this.openSnackBar("Your User Name and Password is locked", this.LoginvalidationMsg['Ok']);

    } else {
      this.selectedrole = null;
      // this.fill_all_helplist(); 
      this.Loggeduser.branchid = data['authViewModels'].branchId;
      this.Loggeduser.branchname = data['authViewModels'].branchName;
      this.Loggeduser.userid = data['authViewModels'].id;
      this.Loggeduser.firstname = data['authViewModels'].firstName;
      this.Loggeduser.usertypeid = data['authViewModels'].userTypeId;
      this.Loggeduser.token = data['authViewModels'].token;
      this.Loggeduser.dashboardrows = data['authViewModels'].dashboardRows;
      this.Loggeduser.sessionInterval = parseInt(data['authViewModels'].sessionInterval);
      this.Loggeduser.specialityId = data['authViewModels'].specialityId;
      this.getuserId = this.Loggeduser.userid;
      this.sameUserLogin();
      this.getcustomthemedata(this.Loggeduser.userid);
      this.GetNameByType('ModuleSpecialityType');

      //console.log("Room id retreived " + this.Loggeduser.roomid);
      this.callForkjoin();
      this.getallusers();
      this.getcheckSIngal();
      this.GetAreaData();
      //console.log(this.Loggeduser);
      // localStorage.setItem('current_user', JSON.stringify(this.Loggeduser.userid));
      if (this.rememberme == true) {

        sessionStorage.setItem('userName', this.Loggeduser.username);
        //  let userpassword = btoa(this.Loggeduser.password);
        //  localStorage.setItem('password', userpassword);
      }
      sessionStorage.setItem('token', JSON.stringify(this.Loggeduser.token));

      //  this.getcategories();
      this.getServertime();
      this.tourGuideDashboard = false;
      this.getwebConfigAPI();
      this.getsmsConfigAPI(this.Loggeduser.branchid);
      this.getwebstorage();
    }
  }

  callForkjoin() {
    forkJoin({
      userdata: this.get_master_Config(),
      getcompaniesdata: this.getcompanies(),
      getbillingdata: this.getbillingcompanies(),
      getfinyeardata: this.getfinyear(),
      branchdatadata: this.getallbranches(),
      activeuserdata: this.getactiveusers(),
      getlanguagedata: this.getLanguageMaster(),
      roledata: this.getroles(),
      getroomdata: this.getrooms()
    })
      .subscribe(
        (results: any) => {
          this.success_usermaster(results.userdata);
          this.successcompanies(results.getcompaniesdata);
          this.successbillcompanies(results.getbillingdata)
          this.successfinyear(results.getfinyeardata);
          this.successbranches(results.branchdatadata)
          this.successactiveusers(results.activeuserdata)
          this.successlanguage(results.getlanguagedata)
          this.successroles(results.roledata)
          this.successrooms(results.getroomdata)


        },
        (err) => {

          // this.openSnackBar("API Failed", "ok");
        }
      );
  }
  getwebstorage() {
    this.http.get<any>(this.newbaseUrl + "Common/GetStorageType").
      subscribe(data => this.successwebstorage(data), err => this.failedstorage(err));

  }
  successwebstorage(data) {
    this.webstorageConfigobj = {};
    this.webstorageConfigobj = data;
  }
  failedstorage(err) {

  }
  sameUserLogin() {

    this.http.get<any>(this.newbaseUrl + "UserMaster/CheckLoginCountByUserId").
      subscribe(data => this.successSameUserLogin(data), err => this.failedlogin(err));

  }

  successSameUserLogin(data: any) {

    if (data.loginCount > 1) {
      this.SameUserLogin = true;
    } else {
      this.SameUserLogin = false;
      this.showcompanybox = true;
      this.showloginbox = false;
      this.openSnackBar(this.LoginvalidationMsg['loginMsg'], this.LoginvalidationMsg['Ok']);
    }

  }
  serverDateTime() {
    return this.http.get<any>(this.newbaseUrl + "Common/GetServerDateTime");
  }
  getServertime() {
    this.serverDateTime().subscribe(data => this.success_ServerTime(data), err => this.failed_ServerTime(err)
    )
  }
  success_ServerTime(data) {
    this.getServerDate = null;
    this.serverTime = null;
    sessionStorage.setItem('SessionTime', JSON.stringify(data.serverTime));
    sessionStorage.setItem('Sessiondate', JSON.stringify(data.serverDate));
    this.getServerDate = data.serverDate;
    this.serverTime = data.serverTime;
    this.loadtime(data.serverDate, data.serverTime);
  }
  loadtime(sdate: any, stime: any) {
    // if(this.Loggeduser.sessionInterval >0){
    //   const uid:any=JSON.parse( localStorage.getItem('current_user'));
    //   if(uid >0){
    //     let payload={
    //       "FK_UserId":uid,
    //       "Token":JSON.parse(sessionStorage.getItem('token')),
    //       "IsActive":1,
    //       "SessionInterval": this.Loggeduser.sessionInterval
    //     };
    //   this.timeInterval=  setInterval(() => {
    //     let promise = new Promise<void>((resolve, reject) => {

    //       this.http.post(this.newbaseUrl + "UpdateRoomLogOut",payload)
    //         .toPromise()
    //         .then(
    //           res => { 
    //             resolve();
    //           },
    //           msg => { 
    //           reject(msg);
    //           }
    //         );
    //     });
    //     return promise;

    //   }, this.Loggeduser.sessionInterval * 60000);

    // }
    // }

    const dateFromPicker = sdate;
    const timeFromPicker = stime;
    const dateParts = dateFromPicker.split("-");
    this.timeParts = timeFromPicker.split(":");
    let localDatetime = new Date(dateParts[0], dateParts[1] - 1, dateParts[2], this.timeParts[0], this.timeParts[1], this.timeParts[2]);
    let second = localDatetime.getSeconds();
    let hr = localDatetime.getHours();
    let min = localDatetime.getMinutes();

    setInterval(() => {
      second = second + 1;
      if (second >= 60) {
        min = min + 1;
        second = 0;
      } else if (min >= 60) {
        hr = hr + 1;
        min = 0;
      }
      const dateFromPicker = sdate;
      const dateParts = dateFromPicker.split("-");
      this.localDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2], hr, min, second);
      sessionStorage.setItem('SessiondateTime', JSON.stringify(this.localDate));
    }, 1000);



  }

  failed_ServerTime(err) {
    console.log('Failed API')
  }



  failedlogin(err) {

    this.dialog.closeAll();
    //  this.showspinner = false;
    if (err.status == 400) {
      this.logincapcha.CAns = null;
      this.openSnackBar('Incorrect captcha, please enter correct captcha.', this.LoginvalidationMsg['Ok']);
      this.refreshgeneratecapta();
    } else {
      this.openSnackBar(this.LoginvalidationMsg['loginErrMsg'], this.LoginvalidationMsg['Ok']);
      this.Loggeduser = {};
      this.router.navigateByUrl('/', { replaceUrl: true }).then(() =>
        this.router.navigate(['']));
    }

  }

  successfinyear(data: any) {
    // console.log('fin year',data);
    this.FinYears = data;
    // var index = this.FinYears.length - 1
    // console.log(index)
    this.Loggeduser.finyear = this.FinYears[0].pkFinYearId;

  }

  failedfinyear(err) {

  }
  branchesobject: any = {};
  successbranches(data) {
    this.branchesobject = {};
    this.Branches = data;
    //this.Branches[1].isActive = false;
    this.Branches = this.Branches.filter(b => b.isActive == true);
    const checkbranchobj = this.Branches.filter(item => item.pkBranchId == this.Loggeduser.branchid);
    if (checkbranchobj.length > 0) {
      this.branchesobject = checkbranchobj[0];
    }
    // this.selectedbranch = 1;
    //this.Loggeduser.branchid = this.selectedbranch;
    //console.log(data);
  }
  failedbranches(err) {

  }
  successactiveusers(data) {
    this.activatedusers = data;
    this.Loggeduser.numberofusersloggedin = this.activatedusers;
  }
  failedactiveusers(err) {
    console.log(err);
  }
  success_password_change(data) {
    // console.log('change pass',data);
    this.showchangepasswordbox = false;
    this.showforgotpasswordbox = false;
    this.showloginbox = true;
    this.Loggeduser.username = null;
    this.Loggeduser.password = null;
    this.oldpasswordtyped = null;
    this.Loggeduser.sessionInterval = null;
    this.newpassword = null;
    this.confirmpassword = null;
    this.openSnackBar(this.validationMsg['dashboardValidMsg.msg37'], this.validationMsg['Ok']);
    // console.log(data);
  }

  failed_password_change(err) {
    this.openSnackBar(this.validationMsg['dashboardValidMsg.msg25'], this.validationMsg['Ok']);
  }

  showpassword() {
    this.showchangepasswordbox = true;
    this.showcompanybox = false;

  }

  showforgotpassword() {
    this.showforgotpasswordbox = !this.showforgotpasswordbox;
    this.showchangepasswordbox = false;
    this.showloginbox = false
    this.showcompanybox = false;

  }

  gotologin() {
    this.showchangepasswordbox = false;
    this.showcompanybox = true;
  }
  gobacklogin() {
    this.showcompanybox = false;
    this.showloginbox = true;
    this.showforgotpasswordbox = false
    this.Loggedout(1);
  }

  verifyotp() {
    this.showforgotpasswordbox = false
    this.showchangepasswordbox = true;
    this.showloginbox = false
    this.showcompanybox = false;
  }

  changepasswordcheck(opt: any) {
    if (this.oldpasswordtyped !== this.Loggeduser.password)
      this.openSnackBar(this.validationMsg['dashboardValidMsg.msg33'], this.validationMsg['Ok']);
    else {
      if (this.newpassword !== this.confirmpassword)
        this.openSnackBar(this.validationMsg['dashboardValidMsg.msg34'], this.validationMsg['Ok']);
      else {
        if (this.newpassword == this.oldpasswordtyped) {
          this.openSnackBar(this.validationMsg['dashboardValidMsg.msg35'], this.validationMsg['Ok']);
        }
        else {
          // call api to change password
          let payload = {
            UserName: this.Loggeduser.username,
            OTP: opt,
            NewPassword: this.newpassword
          }
          this.changepassword(payload)
            .subscribe(data => this.success_password_change(data),
              err => this.failed_password_change(err));

        }
      }
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    })

  }
  AIlogout(payload:any){
    return this.http.post<any>(this.newbaseUrl + "Usermaster/UpdateStatusLogOut", payload)
  }
  Loggedout(type) {
    // const uid:any=JSON.parse( localStorage.getItem('current_user'));
    //if(uid >0){
    if (type != 0) {
      let payload = {
        "FK_UserId": 0,
        "Token": JSON.parse(sessionStorage.getItem('token')),
        "IsActive": 0,
        "SessionInterval": 0,
      };
      this.http.post<any>(this.newbaseUrl + "Usermaster/UpdateStatusLogOut", payload).subscribe(
        data => this.successstatus(data, type), err => this.failedstatus(err)
      )

    } else {
      let payload = {
        "FK_UserId": 0,
        "Token": JSON.parse(sessionStorage.getItem('token')),
        "IsActive": 0,
        "IsLogOutOtherSession": 1,
        "SessionInterval": 0
      };
      this.http.post<any>(this.newbaseUrl + "Usermaster/UpdateStatusLogOut", payload).subscribe(
        data => this.successstatuslogin(data), err => this.failedstatus(err)
      );
    }
    // }


  }

  successstatuslogin(data) {

  }
  successstatus(data, type) {

    localStorage.clear();
    sessionStorage.removeItem('SessionTime');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('Sessiondate');
    sessionStorage.removeItem('SessiondateTime');
    sessionStorage.clear();
    this.showloginbox = true;
    this.showcompanybox = false;
    this.showchangepasswordbox = false;
    this.Loggeduser.username = null;
    this.Loggeduser.password = null;
    this.Loggeduser.sessionInterval = null;
    this.langcontent.next('en');
    this.Loggeduser.token = null;
    this.ngOnDestroy();
    if (type == 2) {
      window.location.reload();
    } else {
      this.router.navigate(['/login'], { replaceUrl: true });
    }

  }
  ngOnDestroy() {
    clearInterval(this.timeInterval);
  }
  failedstatus(err) {
    localStorage.clear();
    sessionStorage.removeItem('SessionTime');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('Sessiondate');
    sessionStorage.removeItem('SessiondateTime');
    this.showloginbox = true;
    this.showcompanybox = false;
    this.showchangepasswordbox = false;
    this.Loggeduser.username = null;
    this.Loggeduser.password = null;
    this.Loggeduser.sessionInterval = null;
    this.ngOnDestroy();
    this.langcontent.next('en');
    this.Loggeduser.token = null;
    this.router.navigate(['/login'], { replaceUrl: true });
  }
  get_master_Config() {
    this.http.get<any>(this.newbaseUrl + "UserMaster/GetUser").subscribe(
      data => this.success_usermaster(data), err => this.failed_usermaster(err)
    )
  }
  success_usermaster(data) {
    this.masterdata = data;
    this.Loggeduser.roomid = parseInt(data.fK_LoginRoomID);
    this.Loggeduser.room = data.roomNo;
    this.LoginsubSpecialityName = this.masterdata.fkSubSpecialtyId;
    this.Loggeduser.pUserName =data.userName;
    // this.getrooms();
  }
  failed_usermaster(err) {

  }


  getToken() {
    return this.Loggeduser.token;
  }


  IsAuthenticated() {
    let todayDate = new Date();
    let hrs = todayDate.getHours()
    let mins = todayDate.getMinutes()
    var sesstime = JSON.parse(sessionStorage.getItem('SessionTime'));

    if (this.Loggeduser.username != null) {
      return true;
    }
    else {
      return false;
    }

  }


  refereshonjects() {
    this.bodybgobj = {};
    this.bodytxtobj = {};
    this.bodyfontsizeobj = {};
    this.bodyfontfamilyobj = {};
    this.headerbgobj = {};
    this.headertxtobj = {};
    this.pagebgobj = {};
    this.pagetxtobj = {};
    this.pagefontsizeobj = {};
    this.pagefontfamilyobj = {};
    this.pagebtnobj = {};
    this.pagebtn2obj = {};
    this.inputbgobj = {};
    this.inputtxtobj = {};
    this.tableheadingbgobj = {};
    this.tableheadingtxtobj = {};
    this.tabledatabgobj = {};
    this.tabledatatxtobj = {};
    this.tableheadingfontsizeobj = {};
    this.tabledatafontsizeobj = {};
    this.iconbgobj = {};
    this.icontxtobj = {};
    this.sidebarbgobj = {};
    this.sidebartxtobj = {};

  }





  setdefailthem() {
    // console.log('default with db');
    this.checkThemeStatus = 1;
    this.selectedTheme = "Default";
    var bodydata: any = [];
    var headedata: any = [];
    var pagesdata: any = [];
    var inputdata: any = [];
    var tabledata: any = [];
    var sideBarData: any = [];
    var iconsData: any = [];
    // bodydata=this.defaultThemeAray.filter(item=>item.theme=='Default' &&item.tag =='body');
    // headedata=this.defaultThemeAray.filter(item=>item.theme=='Default' &&item.tag =='header');
    // pagesdata=this.defaultThemeAray.filter(item=>item.theme=='Default' &&item.tag =='page');
    // inputdata=this.defaultThemeAray.filter(item=>item.theme=='Default' &&item.tag =='input');
    // tabledata=this.defaultThemeAray.filter(item=>item.theme=='Default' &&item.tag =='table');
    // sideBarData=this.defaultThemeAray.filter(item=>item.theme=='Default' &&item.tag =='sidebar');
    // iconsData=this.defaultThemeAray.filter(item=>item.theme=='Default' &&item.tag =='icons');
    if (this.defaultThemeAray.length > 0) {

      for (let i = 0; i < this.defaultThemeAray.length; i++) {
        if (this.defaultThemeAray[i].theme == "Default") {
          if (this.defaultThemeAray[i].tag == "body") {
            bodydata.push(this.defaultThemeAray[i]);

            for (let j = 0; j < bodydata.length; j++) {
              if (bodydata[j].property == "txtcolor") {
                this.changebodycolore(bodydata[j].value);
                this.themedataobj.bodytxtcolor = bodydata[j].value;
              }
              if (bodydata[j].property == "bgcolor") {
                this.changebodybackgroundcolore(bodydata[j].value);
                this.themedataobj.bodybgcolor = bodydata[j].value;


              }

              if (bodydata[j].property == "fontsize") {
                this.changebodybackgroundfontsize(bodydata[j].value);
                this.themedataobj.bodyfontsize = bodydata[j].value;


              }
              if (bodydata[j].property == "fontfamily") {
                this.changebodybackgroundfontfamily(bodydata[j].value);
                this.themedataobj.bodyfontfamily = bodydata[j].value;

              }

            }
          }
          if (this.defaultThemeAray[i].tag == "header") {
            headedata.push(this.defaultThemeAray[i]);
            ////console.log('theme-"header"', headedata);
            for (let j = 0; j < headedata.length; j++) {
              ////console.log('body-data',headedata[j])
              if (headedata[j].property == "bgcolor") {
                this.setheaderbackgroundcolor(headedata[j].value);
                this.themedataobj.headerbgcolor = headedata[j].value;

                //console.log('set default in if headerbg')

              }
              if (headedata[j].property == "txtcolor") {
                this.setheaderlistcolor(headedata[j].value);
                this.themedataobj.headertxtcolor = headedata[j].value;

              }

            }


          }
          if (this.defaultThemeAray[i].tag == "page") {
            pagesdata.push(this.defaultThemeAray[i]);
            ////console.log('theme-"pages"', pagesdata);

            for (let j = 0; j < pagesdata.length; j++) {
              ////console.log('body-data',pagesdata[j])
              if (pagesdata[j].property == "txtcolor") {
                this.changePageHeadingColor(pagesdata[j].value);
                this.themedataobj.pagetxtcolor = pagesdata[j].value;

              }
              if (pagesdata[j].property == "bgcolor") {
                this.changePagebackgroundColor(pagesdata[j].value);
                this.themedataobj.pagebgcolor = pagesdata[j].value;
                //console.log('set default in if pagebg')

              }

              if (pagesdata[j].property == "fontsize") {
                this.changePagefontsize(pagesdata[j].value);
                this.themedataobj.pagefontsize = pagesdata[j].value;

              }
              if (pagesdata[j].property == "fontfamily") {
                this.changePagefontfamily(pagesdata[j].value);
                this.themedataobj.pagefontfamily = pagesdata[j].value;

              }
              if (pagesdata[j].property == "primarybuttoncolor") {
                this.changeButtonsColor(pagesdata[j].value);
                this.themedataobj.pagebtnone = pagesdata[j].value;

              }
              if (pagesdata[j].property == "secondarybuttoncolor") {
                this.changeSecondryButtonsColor(pagesdata[j].value);
                this.themedataobj.pagebtntwo = pagesdata[j].value;
              }
            }
          }
          if (this.defaultThemeAray[i].tag == "input") {
            inputdata.push(this.defaultThemeAray[i]);

            for (let j = 0; j < inputdata.length; j++) {
              if (inputdata[j].property == "bgcolor") {
                this.inputfieldbgcolor(inputdata[j].value);
                this.themedataobj.inputbgcolor = inputdata[j].value;
              }
            }

          }
          if (this.defaultThemeAray[i].tag == "table") {
            tabledata.push(this.defaultThemeAray[i]);
            ////console.log('table-data',tabledata)
            for (let j = 0; j < tabledata.length; j++) {
              if (tabledata[j].property == "headerbgcolor") {
                this.settableheadingbackgeound(tabledata[j].value);
                this.themedataobj.tbheadbgcolor = tabledata[j].value;

              }
              if (tabledata[j].property == "databgcolor") {
                this.settabledatabackgeound(tabledata[j].value);
                this.themedataobj.tbdatabgcolor = tabledata[j].value;

              }

              if (tabledata[j].property == "headertxtcolor") {
                this.settableheadingcolor(tabledata[j].value);
                this.themedataobj.tbheadbgcolor = tabledata[j].value;
              }
              if (tabledata[j].property == "datatxtcolor") {
                this.settabledatacolor(tabledata[j].value);
                this.themedataobj.tbdatatxtcolor = tabledata[j].value;
              }

              if (tabledata[j].property == "headerfontsize") {
                this.settablehaederfont(tabledata[j].value);
                this.themedataobj.tbheadfontsize = tabledata[j].value;

              }
              if (tabledata[j].property == "datafontsize") {
                this.settabledatafont(tabledata[j].value);
                this.themedataobj.tbdatafontsize = tabledata[j].value;

              }

            }
          }
          if (this.defaultThemeAray[i].tag == "sidebar") {
            sideBarData.push(this.defaultThemeAray[i]);
            for (let j = 0; j < sideBarData.length; j++) {
              if (sideBarData[j].property == "txtcolor") {
                this.setsidebartxtcolor(sideBarData[j].value);
                this.themedataobj.sidebartxtcolor = sideBarData[j].value;

              }
              if (sideBarData[j].property == "bgcolor") {
                this.setiSidebarbgcolor(sideBarData[j].value);
                this.themedataobj.sidebarbgcolor = sideBarData[j].value;
              }
            }
          }
          if (this.defaultThemeAray[i].tag == "icons") {
            iconsData.push(this.defaultThemeAray[i]);
            for (let j = 0; j < iconsData.length; j++) {
              if (iconsData[j].property == "txtcolor") {
                this.seticonstxtcolor(iconsData[j].value);
                this.themedataobj.iconstxtcolor = iconsData[j].value


              }
              if (iconsData[j].property == "bgcolor") {
                this.seticonsbgcolor(iconsData[j].value);
                this.themedataobj.iconsbgcolor = iconsData[j].value;

              }
            }
          }
        }

      }
      //console.log('themeobj',this.themedataobj)

    }
    else {
      this.checkThemeStatus = 0;
      console.log('set default without db')
      this.seticonsbgcolor('#1b3465');
      this.seticonstxtcolor('#FFFFFF');
      this.setiSidebarbgcolor('#1b3465');
      this.setsidebartxtcolor('#FFFFFF');
      this.settabledatafont('12px');
      this.settablehaederfont('12px');
      this.settabledatacolor('#000000');
      this.settableheadingcolor('#FFFFFF');
      this.settabledatabackgeound('#FFFFFF');
      this.settableheadingbackgeound('#1b3465');
      this.inputfieldbgcolor('#FFFFFF');
      this.changeSecondryButtonsColor('#323232');
      this.changeButtonsColor('#1b3465');
      this.changePagefontfamily('Open Sans, Roboto, inherit, serif, system-ui');
      this.changePagefontsize('15px');
      this.changePagebackgroundColor('#fffff');
      this.changePageHeadingColor('#000000');
      this.setheaderlistcolor('#ffffff');
      this.setheaderbackgroundcolor('#1b3465');
      this.changebodybackgroundfontfamily('Open Sans, Roboto, inherit, serif, system-ui');
      this.changebodybackgroundfontsize('18px');
      this.changebodybackgroundcolore('#F5F5F5');
      this.changebodycolore('#000000');
    }

  }

  setcusthemeforme() {
    var bodydata: any = [];
    var headedata: any = [];
    var pagesdata: any = [];
    var inputdata: any = [];
    var tabledata: any = [];
    var sideBarData: any = [];
    var iconsData: any = [];
    // console.log('custom with db');
    if (this.customeThemeAray.length > 0) {

      for (let i = 0; i < this.customeThemeAray.length; i++) {
        if (this.customeThemeAray[i].theme == "Custom") {
          if (this.customeThemeAray[i].fk_UserID === this.Loggeduser.userid && this.customeThemeAray[i].isActive == true) {
            //  console.log('custom case one 1')
            this.checkThemeStatus = 2;
            this.selectedTheme = "Custom";
            if (this.customeThemeAray[i].tag == "body") {
              bodydata.push(this.customeThemeAray[i]);

              for (let j = 0; j < bodydata.length; j++) {
                if (bodydata[j].property == "txtcolor") {
                  this.changebodycolore(bodydata[j].value);
                  this.themedataobj.bodytxtcolor = bodydata[j].value;
                }
                if (bodydata[j].property == "bgcolor") {
                  this.changebodybackgroundcolore(bodydata[j].value);
                  this.themedataobj.bodybgcolor = bodydata[j].value;


                }

                if (bodydata[j].property == "fontsize") {
                  this.changebodybackgroundfontsize(bodydata[j].value);
                  this.themedataobj.bodyfontsize = bodydata[j].value;


                }
                if (bodydata[j].property == "fontfamily") {
                  this.changebodybackgroundfontfamily(bodydata[j].value);
                  this.themedataobj.bodyfontfamily = bodydata[j].value;

                }

              }
            }
            if (this.customeThemeAray[i].tag == "header") {
              headedata.push(this.customeThemeAray[i]);
              ////console.log('theme-"header"', headedata);
              for (let j = 0; j < headedata.length; j++) {
                ////console.log('body-data',headedata[j])
                if (headedata[j].property == "bgcolor") {
                  this.setheaderbackgroundcolor(headedata[j].value);
                  this.themedataobj.headerbgcolor = headedata[j].value;

                  //console.log('set default in if headerbg')

                }
                if (headedata[j].property == "txtcolor") {
                  this.setheaderlistcolor(headedata[j].value);
                  this.themedataobj.headertxtcolor = headedata[j].value;

                }

              }


            }
            if (this.customeThemeAray[i].tag == "page") {
              pagesdata.push(this.customeThemeAray[i]);
              ////console.log('theme-"pages"', pagesdata);

              for (let j = 0; j < pagesdata.length; j++) {
                ////console.log('body-data',pagesdata[j])
                if (pagesdata[j].property == "txtcolor") {
                  this.changePageHeadingColor(pagesdata[j].value);
                  this.themedataobj.pagetxtcolor = pagesdata[j].value;

                }
                if (pagesdata[j].property == "bgcolor") {
                  this.changePagebackgroundColor(pagesdata[j].value);
                  this.themedataobj.pagebgcolor = pagesdata[j].value;
                  //console.log('set default in if pagebg')

                }

                if (pagesdata[j].property == "fontsize") {
                  this.changePagefontsize(pagesdata[j].value);
                  this.themedataobj.pagefontsize = pagesdata[j].value;

                }
                if (pagesdata[j].property == "fontfamily") {
                  this.changePagefontfamily(pagesdata[j].value);
                  this.themedataobj.pagefontfamily = pagesdata[j].value;

                }
                if (pagesdata[j].property == "primarybuttoncolor") {
                  this.changeButtonsColor(pagesdata[j].value);
                  this.themedataobj.pagebtnone = pagesdata[j].value;

                }
                if (pagesdata[j].property == "secondarybuttoncolor") {
                  this.changeSecondryButtonsColor(pagesdata[j].value);
                  this.themedataobj.pagebtntwo = pagesdata[j].value;
                }
              }
            }
            if (this.customeThemeAray[i].tag == "input") {
              inputdata.push(this.customeThemeAray[i]);

              for (let j = 0; j < inputdata.length; j++) {
                if (inputdata[j].property == "bgcolor") {
                  this.inputfieldbgcolor(inputdata[j].value);
                  this.themedataobj.inputbgcolor = inputdata[j].value;
                }
              }

            }
            if (this.customeThemeAray[i].tag == "table") {
              tabledata.push(this.customeThemeAray[i]);
              ////console.log('table-data',tabledata)
              for (let j = 0; j < tabledata.length; j++) {
                if (tabledata[j].property == "headerbgcolor") {
                  this.settableheadingbackgeound(tabledata[j].value);
                  this.themedataobj.tbheadbgcolor = tabledata[j].value;

                }
                if (tabledata[j].property == "databgcolor") {
                  this.settabledatabackgeound(tabledata[j].value);
                  this.themedataobj.tbdatabgcolor = tabledata[j].value;

                }

                if (tabledata[j].property == "headertxtcolor") {
                  this.settableheadingcolor(tabledata[j].value);
                  this.themedataobj.tbheadbgcolor = tabledata[j].value;
                }
                if (tabledata[j].property == "datatxtcolor") {
                  this.settabledatacolor(tabledata[j].value);
                  this.themedataobj.tbdatatxtcolor = tabledata[j].value;
                }

                if (tabledata[j].property == "headerfontsize") {
                  this.settablehaederfont(tabledata[j].value);
                  this.themedataobj.tbheadfontsize = tabledata[j].value;

                }
                if (tabledata[j].property == "datafontsize") {
                  this.settabledatafont(tabledata[j].value);
                  this.themedataobj.tbdatafontsize = tabledata[j].value;

                }

              }
            }
            if (this.customeThemeAray[i].tag == "sidebar") {
              sideBarData.push(this.customeThemeAray[i]);
              for (let j = 0; j < sideBarData.length; j++) {
                if (sideBarData[j].property == "txtcolor") {
                  this.setsidebartxtcolor(sideBarData[j].value);
                  this.themedataobj.sidebartxtcolor = sideBarData[j].value;

                }
                if (sideBarData[j].property == "bgcolor") {
                  this.setiSidebarbgcolor(sideBarData[j].value);
                  this.themedataobj.sidebarbgcolor = sideBarData[j].value;
                }
              }
            }
            if (this.customeThemeAray[i].tag == "icons") {
              iconsData.push(this.customeThemeAray[i]);
              for (let j = 0; j < iconsData.length; j++) {
                if (iconsData[j].property == "txtcolor") {
                  this.seticonstxtcolor(iconsData[j].value);
                  this.themedataobj.iconstxtcolor = iconsData[j].value


                }
                if (iconsData[j].property == "bgcolor") {
                  this.seticonsbgcolor(iconsData[j].value);
                  this.themedataobj.iconsbgcolor = iconsData[j].value;

                }
              }
            }

          }
          else if (this.customeThemeAray[i].fk_UserID === this.Loggeduser.userid && this.customeThemeAray[i].isActive == false) {
            // console.log('custom case one 2') 
            this.checkThemeStatus = 1;
            this.selectedTheme = "Default";
            if (this.customeThemeAray[i].tag == "body") {
              bodydata.push(this.customeThemeAray[i]);

              for (let j = 0; j < bodydata.length; j++) {
                if (bodydata[j].property == "txtcolor") {
                  this.changebodycolore(bodydata[j].value);
                  this.themedataobj.bodytxtcolor = bodydata[j].value;
                }
                if (bodydata[j].property == "bgcolor") {
                  this.changebodybackgroundcolore(bodydata[j].value);
                  this.themedataobj.bodybgcolor = bodydata[j].value;


                }

                if (bodydata[j].property == "fontsize") {
                  this.changebodybackgroundfontsize(bodydata[j].value);
                  this.themedataobj.bodyfontsize = bodydata[j].value;


                }
                if (bodydata[j].property == "fontfamily") {
                  this.changebodybackgroundfontfamily(bodydata[j].value);
                  this.themedataobj.bodyfontfamily = bodydata[j].value;

                }

              }
            }
            if (this.customeThemeAray[i].tag == "header") {
              headedata.push(this.customeThemeAray[i]);
              ////console.log('theme-"header"', headedata);
              for (let j = 0; j < headedata.length; j++) {
                ////console.log('body-data',headedata[j])
                if (headedata[j].property == "bgcolor") {
                  this.setheaderbackgroundcolor(headedata[j].value);
                  this.themedataobj.headerbgcolor = headedata[j].value;

                  //console.log('set default in if headerbg')

                }
                if (headedata[j].property == "txtcolor") {
                  this.setheaderlistcolor(headedata[j].value);
                  this.themedataobj.headertxtcolor = headedata[j].value;

                }

              }


            }
            if (this.customeThemeAray[i].tag == "page") {
              pagesdata.push(this.customeThemeAray[i]);
              ////console.log('theme-"pages"', pagesdata);

              for (let j = 0; j < pagesdata.length; j++) {
                ////console.log('body-data',pagesdata[j])
                if (pagesdata[j].property == "txtcolor") {
                  this.changePageHeadingColor(pagesdata[j].value);
                  this.themedataobj.pagetxtcolor = pagesdata[j].value;

                }
                if (pagesdata[j].property == "bgcolor") {
                  this.changePagebackgroundColor(pagesdata[j].value);
                  this.themedataobj.pagebgcolor = pagesdata[j].value;
                  //console.log('set default in if pagebg')

                }

                if (pagesdata[j].property == "fontsize") {
                  this.changePagefontsize(pagesdata[j].value);
                  this.themedataobj.pagefontsize = pagesdata[j].value;

                }
                if (pagesdata[j].property == "fontfamily") {
                  this.changePagefontfamily(pagesdata[j].value);
                  this.themedataobj.pagefontfamily = pagesdata[j].value;

                }
                if (pagesdata[j].property == "primarybuttoncolor") {
                  this.changeButtonsColor(pagesdata[j].value);
                  this.themedataobj.pagebtnone = pagesdata[j].value;

                }
                if (pagesdata[j].property == "secondarybuttoncolor") {
                  this.changeSecondryButtonsColor(pagesdata[j].value);
                  this.themedataobj.pagebtntwo = pagesdata[j].value;
                }
              }
            }
            if (this.customeThemeAray[i].tag == "input") {
              inputdata.push(this.customeThemeAray[i]);

              for (let j = 0; j < inputdata.length; j++) {
                if (inputdata[j].property == "bgcolor") {
                  this.inputfieldbgcolor(inputdata[j].value);
                  this.themedataobj.inputbgcolor = inputdata[j].value;
                }
              }

            }
            if (this.customeThemeAray[i].tag == "table") {
              tabledata.push(this.customeThemeAray[i]);
              ////console.log('table-data',tabledata)
              for (let j = 0; j < tabledata.length; j++) {
                if (tabledata[j].property == "headerbgcolor") {
                  this.settableheadingbackgeound(tabledata[j].value);
                  this.themedataobj.tbheadbgcolor = tabledata[j].value;

                }
                if (tabledata[j].property == "databgcolor") {
                  this.settabledatabackgeound(tabledata[j].value);
                  this.themedataobj.tbdatabgcolor = tabledata[j].value;

                }

                if (tabledata[j].property == "headertxtcolor") {
                  this.settableheadingcolor(tabledata[j].value);
                  this.themedataobj.tbheadbgcolor = tabledata[j].value;
                }
                if (tabledata[j].property == "datatxtcolor") {
                  this.settabledatacolor(tabledata[j].value);
                  this.themedataobj.tbdatatxtcolor = tabledata[j].value;
                }

                if (tabledata[j].property == "headerfontsize") {
                  this.settablehaederfont(tabledata[j].value);
                  this.themedataobj.tbheadfontsize = tabledata[j].value;

                }
                if (tabledata[j].property == "datafontsize") {
                  this.settabledatafont(tabledata[j].value);
                  this.themedataobj.tbdatafontsize = tabledata[j].value;

                }

              }
            }
            if (this.customeThemeAray[i].tag == "sidebar") {
              sideBarData.push(this.customeThemeAray[i]);
              for (let j = 0; j < sideBarData.length; j++) {
                if (sideBarData[j].property == "txtcolor") {
                  this.setsidebartxtcolor(sideBarData[j].value);
                  this.themedataobj.sidebartxtcolor = sideBarData[j].value;

                }
                if (sideBarData[j].property == "bgcolor") {
                  this.setiSidebarbgcolor(sideBarData[j].value);
                  this.themedataobj.sidebarbgcolor = sideBarData[j].value;
                }
              }
            }
            if (this.customeThemeAray[i].tag == "icons") {
              iconsData.push(this.customeThemeAray[i]);
              for (let j = 0; j < iconsData.length; j++) {
                if (iconsData[j].property == "txtcolor") {
                  this.seticonstxtcolor(iconsData[j].value);
                  this.themedataobj.iconstxtcolor = iconsData[j].value


                }
                if (iconsData[j].property == "bgcolor") {
                  this.seticonsbgcolor(iconsData[j].value);
                  this.themedataobj.iconsbgcolor = iconsData[j].value;

                }
              }
            }

          }

        }

      }
    }
    else {
      this.setdefailthem();
    }


  }


  changebodybackgroundcolore(color: any) {
    document.documentElement.style.setProperty('--bodybackground-colour', color);
    this.themedataobj.bodybgcolor = color;
    //  debugger; 
    this.bodybgobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "body",
      "property": "bgcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {

          if (this.customeThemeAray[a].tag == 'body' && this.customeThemeAray[a].property == 'bgcolor') {
            this.bodybgtransId = this.customeThemeAray[a].pK_TranId;
            // console.log(this.customeThemeAray[a].pK_TranId, this.bodybgtransId);
            this.bodybgobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.bodybgobj.theme = 'Custom';
            this.bodybgobj.fk_UserID = this.Loggeduser.userid;
            this.bodybgobj.tag = 'body';
            this.bodybgobj.fK_CreatedById = this.Loggeduser.userid;
            this.bodybgobj.value = color;
          }
        }
      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'body' && this.defaultThemeAray[a].property == 'bgcolor') {
          this.bodybgobj.pK_TranId = 0;
          this.bodybgtransId = 0;
          this.bodybgobj.theme = 'Custom';
          this.bodybgobj.tag = 'body';
          this.bodybgobj.value = color;
          this.bodybgobj.fk_UserID = this.Loggeduser.userid;
          this.bodybgobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }

  changebodycolore(color: any) {
    //  debugger; 
    document.documentElement.style.setProperty('--bodycolor-value', color);
    this.bodytxtobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "body",
      "property": "txtcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'body' && this.customeThemeAray[a].property == 'txtcolor') {
            this.bodytxtobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.bodytxtobj.theme = 'Custom';
            this.bodytxtobj.fk_UserID = this.Loggeduser.userid;
            this.bodytxtobj.tag = 'body';
            this.bodytxtobj.fK_CreatedById = this.Loggeduser.userid;
            this.bodytxtobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'body' && this.defaultThemeAray[a].property == 'txtcolor') {
          this.bodytxtobj.pK_TranId = 0;
          this.bodytxtobj.theme = 'Custom';
          this.bodytxtobj.tag = 'body';
          this.bodytxtobj.value = color;
          this.bodytxtobj.fk_UserID = this.Loggeduser.userid;
          this.bodytxtobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }
    this.themedataobj.bodytxtcolor = color;
  }


  setheaderbackgroundcolor(color: any) {
    document.documentElement.style.setProperty('--loginheadbg-colour', color);
    this.themedataobj.headerbgcolor = color;

    this.headerbgobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "header",
      "property": "bgcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'header' && this.customeThemeAray[a].property == 'bgcolor') {
            this.headerbgobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.headerbgobj.theme = 'Custom';
            this.headerbgobj.fk_UserID = this.Loggeduser.userid;
            this.headerbgobj.tag = 'header';
            this.headerbgobj.fK_CreatedById = this.Loggeduser.userid;
            this.headerbgobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'header' && this.defaultThemeAray[a].property == 'bgcolor') {
          this.headerbgobj.pK_TranId = 0;
          this.headerbgobj.theme = 'Custom';
          this.headerbgobj.tag = 'header';
          this.headerbgobj.value = color;
          this.headerbgobj.fk_UserID = this.Loggeduser.userid;
          this.headerbgobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }



  setheaderlistcolor(color: any) {

    document.documentElement.style.setProperty('--loginheadlist-colour', color);
    this.themedataobj.headertxtcolor = color;

    this.headertxtobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "header",
      "property": "txtcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'header' && this.customeThemeAray[a].property == 'txtcolor') {
            this.headertxtobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.headertxtobj.theme = 'Custom';
            this.headertxtobj.fk_UserID = this.Loggeduser.userid;
            this.headertxtobj.tag = 'header';
            this.headertxtobj.fK_CreatedById = this.Loggeduser.userid;
            this.headertxtobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'header' && this.defaultThemeAray[a].property == 'txtcolor') {
          this.headertxtobj.pK_TranId = 0;
          this.headertxtobj.theme = 'Custom';
          this.headertxtobj.tag = 'header';
          this.headertxtobj.value = color;
          this.headertxtobj.fk_UserID = this.Loggeduser.userid;
          this.headertxtobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }


  }

  changePagebackgroundColor(color: any) {
    document.documentElement.style.setProperty('--componetbackground-colour', color);
    this.themedataobj.pagebgcolor = color;


    this.pagebgobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "page",
      "property": "bgcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'page' && this.customeThemeAray[a].property == 'bgcolor') {
            this.pagebgobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.pagebgobj.theme = 'Custom';
            this.pagebgobj.fk_UserID = this.Loggeduser.userid;
            this.pagebgobj.tag = 'page';
            this.pagebgobj.fK_CreatedById = this.Loggeduser.userid;
            this.pagebgobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'page' && this.defaultThemeAray[a].property == 'bgcolor') {
          this.pagebgobj.pK_TranId = 0;
          this.pagebgobj.theme = 'Custom';
          this.pagebgobj.tag = 'page';
          this.pagebgobj.value = color;
          this.pagebgobj.fk_UserID = this.Loggeduser.userid;
          this.pagebgobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }


  changePageHeadingColor(color: any) {
    document.documentElement.style.setProperty('--pageHeading-colour', color);
    this.themedataobj.pagetxtcolor = color;

    this.pagetxtobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "page",
      "property": "txtcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'page' && this.customeThemeAray[a].property == 'txtcolor') {
            this.pagetxtobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.pagetxtobj.theme = 'Custom';
            this.pagetxtobj.fk_UserID = this.Loggeduser.userid;
            this.pagetxtobj.tag = 'page';
            this.pagetxtobj.fK_CreatedById = this.Loggeduser.userid;
            this.pagetxtobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'page' && this.defaultThemeAray[a].property == 'txtcolor') {
          this.pagetxtobj.pK_TranId = 0;
          this.pagetxtobj.theme = 'Custom';
          this.pagetxtobj.tag = 'page';
          this.pagetxtobj.value = color;
          this.pagetxtobj.fk_UserID = this.Loggeduser.userid;
          this.pagetxtobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }
  }


  changePagemargin(color) {
    document.documentElement.style.setProperty('--compmargin-value', color);


  }

  changePagePadding(color) {
    document.documentElement.style.setProperty('--compopadding-value', color);
  }
  changePageBodercolor(color) {
    document.documentElement.style.setProperty('--compboder-value', color);
  }

  changePagefontsize(color: any) {
    document.documentElement.style.setProperty('--compfontsize-value', color);
    this.themedataobj.pagefontsize = color;

    this.pagefontsizeobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "page",
      "property": "fontsize",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'page' && this.customeThemeAray[a].property == 'fontsize') {
            this.pagefontsizeobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.pagefontsizeobj.theme = 'Custom';
            this.pagefontsizeobj.fk_UserID = this.Loggeduser.userid;
            this.pagefontsizeobj.tag = 'page';
            this.pagefontsizeobj.fK_CreatedById = this.Loggeduser.userid;
            this.pagefontsizeobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'page' && this.defaultThemeAray[a].property == 'fontsize') {
          this.pagefontsizeobj.pK_TranId = 0;
          this.pagefontsizeobj.theme = 'Custom';
          this.pagefontsizeobj.tag = 'page';
          this.pagefontsizeobj.value = color;
          this.pagefontsizeobj.fk_UserID = this.Loggeduser.userid;
          this.pagefontsizeobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }

  changePagefontfamily(color: any) {
    document.documentElement.style.setProperty('--compfontfamily-value', color);
    this.themedataobj.pagefontfamily = color;

    this.pagefontfamilyobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "page",
      "property": "fontfamily",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'page' && this.customeThemeAray[a].property == 'fontfamily') {
            this.pagefontfamilyobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.pagefontfamilyobj.theme = 'Custom';
            this.pagefontfamilyobj.fk_UserID = this.Loggeduser.userid;
            this.pagefontfamilyobj.tag = 'page';
            this.pagefontfamilyobj.fK_CreatedById = this.Loggeduser.userid;
            this.pagefontfamilyobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'page' && this.defaultThemeAray[a].property == 'fontfamily') {
          this.pagefontfamilyobj.pK_TranId = 0;
          this.pagefontfamilyobj.theme = 'Custom';
          this.pagefontfamilyobj.tag = 'page';
          this.pagefontfamilyobj.value = color;
          this.pagefontfamilyobj.fk_UserID = this.Loggeduser.userid;
          this.pagefontfamilyobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }

  changeButtonsColor(color: any) {
    document.documentElement.style.setProperty('--pageButton-colour', color);
    this.themedataobj.pagebtnone = color;


    this.pagebtnobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "page",
      "property": "primarybuttoncolor",
      "value": '#1b3465',
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'page' && this.customeThemeAray[a].property == 'primarybuttoncolor') {
            this.pagebtnobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.pagebtnobj.theme = 'Custom';
            this.pagebtnobj.fk_UserID = this.Loggeduser.userid;
            this.pagebtnobj.tag = 'page';
            this.pagebtnobj.fK_CreatedById = this.Loggeduser.userid;
            this.pagebtnobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'page' && this.defaultThemeAray[a].property == 'primarybuttoncolor') {
          this.pagebtnobj.pK_TranId = 0;
          this.pagebtnobj.theme = 'Custom';
          this.pagebtnobj.tag = 'page';
          this.pagebtnobj.value = color;
          this.pagebtnobj.fk_UserID = this.Loggeduser.userid;
          this.pagebtnobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }



  changeSecondryButtonsColor(color: any) {
    document.documentElement.style.setProperty('--pageButtoncancel-colour', color);
    this.themedataobj.pagebtntwo = color;

    this.pagebtn2obj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "page",
      "property": "secondarybuttoncolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'page' && this.customeThemeAray[a].property == 'secondarybuttoncolor') {
            this.pagebtn2obj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.pagebtn2obj.theme = 'Custom';
            this.pagebtn2obj.fk_UserID = this.Loggeduser.userid;
            this.pagebtn2obj.tag = 'page';
            this.pagebtn2obj.fK_CreatedById = this.Loggeduser.userid;
            this.pagebtn2obj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'page' && this.defaultThemeAray[a].property == 'secondarybuttoncolor') {
          this.pagebtn2obj.pK_TranId = 0;
          this.pagebtn2obj.theme = 'Custom';
          this.pagebtn2obj.tag = 'page';
          this.pagebtn2obj.value = color;
          this.pagebtn2obj.fk_UserID = this.Loggeduser.userid;
          this.pagebtn2obj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }
  }

  changelistHoverColor(color: any) {
    document.documentElement.style.setProperty('--listhover-colour', color);
  }

  changebodybackgroundfontsize(color: any) {
    document.documentElement.style.setProperty('--bodyfontsize-value', color);
    this.themedataobj.bodyfontsize = color;
    this.bodyfontsizeobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "body",
      "property": "fontsize",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'body' && this.customeThemeAray[a].property == 'fontsize') {
            this.bodyfontsizeobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.bodyfontsizeobj.theme = 'Custom';
            this.bodyfontsizeobj.fk_UserID = this.Loggeduser.userid;
            this.bodyfontsizeobj.tag = 'body';
            this.bodyfontsizeobj.fK_CreatedById = this.Loggeduser.userid;
            this.bodyfontsizeobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'body' && this.defaultThemeAray[a].property == 'fontsize') {
          this.bodyfontsizeobj.pK_TranId = 0;
          this.bodyfontsizeobj.theme = 'Custom';
          this.bodyfontsizeobj.tag = 'body';
          this.bodyfontsizeobj.value = color;
          this.bodyfontsizeobj.fk_UserID = this.Loggeduser.userid;
          this.bodyfontsizeobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }


  changebodybackgroundfontfamily(color: any) {
    document.documentElement.style.setProperty('--bodyfontfamily-value', color);
    this.themedataobj.bodyfontfamily = color;

    this.bodyfontfamilyobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "body",
      "property": "fontfamily",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'body' && this.customeThemeAray[a].property == 'fontfamily') {
            this.bodyfontfamilyobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.bodyfontfamilyobj.theme = 'Custom';
            this.bodyfontfamilyobj.fk_UserID = this.Loggeduser.userid;
            this.bodyfontfamilyobj.tag = 'body';
            this.bodyfontfamilyobj.fK_CreatedById = this.Loggeduser.userid;
            this.bodyfontfamilyobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'body' && this.defaultThemeAray[a].property == 'fontfamily') {
          this.bodyfontfamilyobj.pK_TranId = 0;
          this.bodyfontfamilyobj.theme = 'Custom';
          this.bodyfontfamilyobj.tag = 'body';
          this.bodyfontfamilyobj.value = color;
          this.bodyfontfamilyobj.fk_UserID = this.Loggeduser.userid;
          this.bodyfontfamilyobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }

  inputfieldbgcolor(color: any) {
    document.documentElement.style.setProperty('--iputefieldbg-colour', color);
    this.themedataobj.inputbgcolor = color;

    this.inputbgobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "input",
      "property": "bgcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'input' && this.customeThemeAray[a].property == 'bgcolor') {
            this.inputbgobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.inputbgobj.theme = 'Custom';
            this.inputbgobj.fk_UserID = this.Loggeduser.userid;
            this.inputbgobj.tag = 'input';
            this.inputbgobj.fK_CreatedById = this.Loggeduser.userid;
            this.inputbgobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'input' && this.defaultThemeAray[a].property == 'bgcolor') {
          this.inputbgobj.pK_TranId = 0;
          this.inputbgobj.theme = 'Custom';
          this.inputbgobj.tag = 'input';
          this.inputbgobj.value = color;
          this.inputbgobj.fk_UserID = this.Loggeduser.userid;
          this.inputbgobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }
  }


  inputfieldbgcolorafterclick(color: any) {
    document.documentElement.style.setProperty('--iputefieldbgafterclick-colour', color);
  }

  inputfieldcolor(color: any) {
    document.documentElement.style.setProperty('--iputefield-colour', color);
    this.themedataobj.inputtxtcolor = color;

    this.inputtxtobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "input",
      "property": "txtcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'input' && this.customeThemeAray[a].property == 'txtcolor') {
            this.inputtxtobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.inputtxtobj.theme = 'Custom';
            this.inputtxtobj.fk_UserID = this.Loggeduser.userid;
            this.inputtxtobj.tag = 'input';
            this.inputtxtobj.fK_CreatedById = this.Loggeduser.userid;
            this.inputtxtobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'input' && this.defaultThemeAray[a].property == 'txtcolor') {
          this.inputtxtobj.pK_TranId = 0;
          this.inputtxtobj.theme = 'Custom';
          this.inputtxtobj.tag = 'input';
          this.inputtxtobj.value = color;
          this.inputtxtobj.fk_UserID = this.Loggeduser.userid;
          this.inputtxtobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }

  setinputfieldwidth(color: any) {
    document.documentElement.style.setProperty('--iputefieldwidth-value', color);
  }

  // table section

  settableheadingbackgeound(color: any) {
    document.documentElement.style.setProperty('--settbheadingbg-colour', color);
    this.themedataobj.tbheadbgcolor = color;


    this.tableheadingbgobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "table",
      "property": "headerbgcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'table' && this.customeThemeAray[a].property == 'headerbgcolor') {
            this.tableheadingbgobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.tableheadingbgobj.theme = 'Custom';
            this.tableheadingbgobj.fk_UserID = this.Loggeduser.userid;
            this.tableheadingbgobj.tag = 'table';
            this.tableheadingbgobj.fK_CreatedById = this.Loggeduser.userid;
            this.tableheadingbgobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'table' && this.defaultThemeAray[a].property == 'headerbgcolor') {
          this.tableheadingbgobj.pK_TranId = 0;
          this.tableheadingbgobj.theme = 'Custom';
          this.tableheadingbgobj.tag = 'table';
          this.tableheadingbgobj.value = color;
          this.tableheadingbgobj.fk_UserID = this.Loggeduser.userid;
          this.tableheadingbgobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }
  }

  settabledatabackgeound(color: any) {
    document.documentElement.style.setProperty('--settbdatabg-colour', color);
    this.themedataobj.tbdatabgcolor = color;

    this.tabledatabgobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "table",
      "property": "databgcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'table' && this.customeThemeAray[a].property == 'databgcolor') {
            this.tabledatabgobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.tabledatabgobj.theme = 'Custom';
            this.tabledatabgobj.fk_UserID = this.Loggeduser.userid;
            this.tabledatabgobj.tag = 'table';
            this.tabledatabgobj.fK_CreatedById = this.Loggeduser.userid;
            this.tabledatabgobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'table' && this.defaultThemeAray[a].property == 'databgcolor') {
          this.tabledatabgobj.pK_TranId = 0;
          this.tabledatabgobj.theme = 'Custom';
          this.tabledatabgobj.tag = 'table';
          this.tabledatabgobj.value = color;
          this.tabledatabgobj.fk_UserID = this.Loggeduser.userid;
          this.tabledatabgobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }

  settableheadingcolor(color: any) {
    document.documentElement.style.setProperty('--settbheading-colour', color);
    this.themedataobj.tbheadtxtcolor = color;

    this.tableheadingtxtobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "table",
      "property": "headertxtcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'table' && this.customeThemeAray[a].property == 'headertxtcolor') {
            this.tableheadingtxtobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.tableheadingtxtobj.theme = 'Custom';
            this.tableheadingtxtobj.fk_UserID = this.Loggeduser.userid;
            this.tableheadingtxtobj.tag = 'table';
            this.tableheadingtxtobj.fK_CreatedById = this.Loggeduser.userid;
            this.tableheadingtxtobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'table' && this.defaultThemeAray[a].property == 'headertxtcolor') {
          this.tableheadingtxtobj.pK_TranId = 0;
          this.tableheadingtxtobj.theme = 'Custom';
          this.tableheadingtxtobj.tag = 'table';
          this.tableheadingtxtobj.value = color;
          this.tableheadingtxtobj.fk_UserID = this.Loggeduser.userid;
          this.tableheadingtxtobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }

  settabledatacolor(color: any) {
    document.documentElement.style.setProperty('--settbdata-colour', color);
    this.themedataobj.tbdatatxtcolor = color;
    this.tabledatatxtobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "table",
      "property": "datatxtcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'table' && this.customeThemeAray[a].property == 'datatxtcolor') {
            this.tabledatatxtobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.tabledatatxtobj.theme = 'Custom';
            this.tabledatatxtobj.fk_UserID = this.Loggeduser.userid;
            this.tabledatatxtobj.tag = 'table';
            this.tabledatatxtobj.fK_CreatedById = this.Loggeduser.userid;
            this.tabledatatxtobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'table' && this.defaultThemeAray[a].property == 'datatxtcolor') {
          this.tabledatatxtobj.pK_TranId = 0;
          this.tabledatatxtobj.theme = 'Custom';
          this.tabledatatxtobj.tag = 'table';
          this.tabledatatxtobj.value = color;
          this.tabledatatxtobj.fk_UserID = this.Loggeduser.userid;
          this.tabledatatxtobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }
  }

  settablehaederfont(color: any) {
    document.documentElement.style.setProperty('--settbheaderfont-value', color);
    this.themedataobj.tbheadfontsize = color;

    this.tableheadingfontsizeobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "table",
      "property": "headerfontsize",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'table' && this.customeThemeAray[a].property == 'headerfontsize') {
            this.tableheadingfontsizeobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.tableheadingfontsizeobj.theme = 'Custom';
            this.tableheadingfontsizeobj.fk_UserID = this.Loggeduser.userid;
            this.tableheadingfontsizeobj.tag = 'table';
            this.tableheadingfontsizeobj.fK_CreatedById = this.Loggeduser.userid;
            this.tableheadingfontsizeobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'table' && this.defaultThemeAray[a].property == 'headerfontsize') {
          this.tableheadingfontsizeobj.pK_TranId = 0;
          this.tableheadingfontsizeobj.theme = 'Custom';
          this.tableheadingfontsizeobj.tag = 'table';
          this.tableheadingfontsizeobj.value = color;
          this.tableheadingfontsizeobj.fk_UserID = this.Loggeduser.userid;
          this.tableheadingfontsizeobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }
  }


  settabledatafont(color: any) {
    document.documentElement.style.setProperty('--settbdatafont-value', color);
    this.themedataobj.tbdatafontsize = color;


    this.tabledatafontsizeobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "table",
      "property": "datafontsize",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'table' && this.customeThemeAray[a].property == 'datafontsize') {
            this.tabledatafontsizeobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.tabledatafontsizeobj.theme = 'Custom';
            this.tabledatafontsizeobj.fk_UserID = this.Loggeduser.userid;
            this.tabledatafontsizeobj.tag = 'table';
            this.tabledatafontsizeobj.fK_CreatedById = this.Loggeduser.userid;
            this.tabledatafontsizeobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'table' && this.defaultThemeAray[a].property == 'datafontsize') {
          this.tabledatafontsizeobj.pK_TranId = 0;
          this.tabledatafontsizeobj.theme = 'Custom';
          this.tabledatafontsizeobj.tag = 'table';
          this.tabledatafontsizeobj.value = color;
          this.tabledatafontsizeobj.fk_UserID = this.Loggeduser.userid;
          this.tabledatafontsizeobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }
  }

  settableswidth(color) {
    document.documentElement.style.setProperty('--settbwidth-value', color);
  }
  settablesmargin(color) {
    document.documentElement.style.setProperty('--settbmargin-value', color);
  }

  settablespadding(color) {
    document.documentElement.style.setProperty('--settbpadding-value', color);
  }

  // icons

  seticonsbgcolor(color: any) {
    document.documentElement.style.setProperty('--seticonsbg-colour', color);
    this.themedataobj.iconsbgcolor = color;


    this.iconbgobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "icons",
      "property": "bgcolor",
      "value": '#404040',
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'icons' && this.customeThemeAray[a].property == 'bgcolor') {
            this.iconbgobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.iconbgobj.theme = 'Custom';
            this.iconbgobj.fk_UserID = this.Loggeduser.userid;
            this.iconbgobj.tag = 'icons';
            this.iconbgobj.fK_CreatedById = this.Loggeduser.userid;
            this.iconbgobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'icons' && this.defaultThemeAray[a].property == 'bgcolor') {
          this.iconbgobj.pK_TranId = 0;
          this.iconbgobj.theme = 'Custom';
          this.iconbgobj.tag = 'icons';
          this.iconbgobj.value = color;
          this.iconbgobj.fk_UserID = this.Loggeduser.userid;
          this.iconbgobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }
  }
  seticonstxtcolor(color: any) {
    document.documentElement.style.setProperty('--seticonstxt-colour', color);
    this.themedataobj.iconstxtcolor = color;


    this.icontxtobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "icons",
      "property": "txtcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'icons' && this.customeThemeAray[a].property == 'txtcolor') {
            this.icontxtobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.icontxtobj.theme = 'Custom';
            this.icontxtobj.fk_UserID = this.Loggeduser.userid;
            this.icontxtobj.tag = 'icons';
            this.icontxtobj.fK_CreatedById = this.Loggeduser.userid;
            this.icontxtobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'icons' && this.defaultThemeAray[a].property == 'txtcolor') {
          this.icontxtobj.pK_TranId = 0;
          this.icontxtobj.theme = 'Custom';
          this.icontxtobj.tag = 'icons';
          this.icontxtobj.value = color;
          this.icontxtobj.fk_UserID = this.Loggeduser.userid;
          this.icontxtobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }
  }
  setThemefontvalues() {
    this.fontsize = ['9px', '10px', '11px', '12px', '13px', '14px', '15px', '16px', '17px', '18px', '19px', '20px', '21px', '22px']
    this.fontFamily = ['inherit ,Times', 'Times,serif', 'Lato,system-ui', 'inherit,serif', 'serif,system-ui', 'inherit,serif,system-ui']

  }

  setiSidebarbgcolor(color: any) {
    document.documentElement.style.setProperty('--setsidebarbg-colour', color);
    this.themedataobj.sidebarbgcolor = color;

    this.sidebarbgobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "sidebar",
      "property": "bgcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'sidebar' && this.customeThemeAray[a].property == 'bgcolor') {
            this.sidebarbgobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.sidebarbgobj.theme = 'Custom';
            this.sidebarbgobj.fk_UserID = this.Loggeduser.userid;
            this.sidebarbgobj.tag = 'sidebar';
            this.sidebarbgobj.fK_CreatedById = this.Loggeduser.userid;
            this.sidebarbgobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'sidebar' && this.defaultThemeAray[a].property == 'bgcolor') {
          this.sidebarbgobj.pK_TranId = 0;
          this.sidebarbgobj.theme = 'Custom';
          this.sidebarbgobj.tag = 'sidebar';
          this.sidebarbgobj.value = color;
          this.sidebarbgobj.fk_UserID = this.Loggeduser.userid;
          this.sidebarbgobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }
  }
  setsidebartxtcolor(color: any) {
    document.documentElement.style.setProperty('--setsidebartxt-colour', color);
    this.themedataobj.sidebartxtcolor = color;

    this.sidebartxtobj = {
      "pK_TranId": 0,
      "theme": "Default",
      "fk_UserID": 1,
      "tag": "sidebar",
      "property": "txtcolor",
      "value": color,
      "isActive": true,
      "fK_CreatedById": 1,
      "createDateTime": null
    }

    if (this.customeThemeAray.length > 0) {
      for (let a = 0; a < this.customeThemeAray.length; a++) {
        if (this.customeThemeAray[a].fk_UserID === this.Loggeduser.userid) {
          if (this.customeThemeAray[a].tag == 'sidebar' && this.customeThemeAray[a].property == 'txtcolor') {
            this.sidebartxtobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
            this.sidebartxtobj.theme = 'Custom';
            this.sidebartxtobj.fk_UserID = this.Loggeduser.userid;
            this.sidebartxtobj.tag = 'sidebar';
            this.sidebartxtobj.fK_CreatedById = this.Loggeduser.userid;
            this.sidebartxtobj.value = color;
          }
        }

      }
    }
    else if (this.defaultThemeAray.length > 0) {
      for (let a = 0; a < this.defaultThemeAray.length; a++) {
        if (this.defaultThemeAray[a].tag == 'sidebar' && this.defaultThemeAray[a].property == 'txtcolor') {
          this.sidebartxtobj.pK_TranId = 0;
          this.sidebartxtobj.theme = 'Custom';
          this.sidebartxtobj.tag = 'sidebar';
          this.sidebartxtobj.value = color;
          this.sidebartxtobj.fk_UserID = this.Loggeduser.userid;
          this.sidebartxtobj.fK_CreatedById = this.Loggeduser.userid;
        }
      }

    }

  }

  closedialog() {
    this.dialog.closeAll();
  }

  savethemeData() {
    var Arrayobj = [];
    Arrayobj.push(this.bodybgobj);
    Arrayobj.push(this.bodytxtobj);
    Arrayobj.push(this.bodyfontsizeobj);
    Arrayobj.push(this.bodyfontfamilyobj);
    Arrayobj.push(this.headerbgobj);
    Arrayobj.push(this.headertxtobj);
    Arrayobj.push(this.pagebgobj);
    Arrayobj.push(this.pagetxtobj);
    Arrayobj.push(this.pagefontsizeobj);
    Arrayobj.push(this.pagefontfamilyobj);
    Arrayobj.push(this.pagebtnobj);
    Arrayobj.push(this.pagebtn2obj);
    Arrayobj.push(this.inputbgobj);
    Arrayobj.push(this.tableheadingbgobj);
    Arrayobj.push(this.tableheadingtxtobj)
    Arrayobj.push(this.tabledatabgobj);
    Arrayobj.push(this.tabledatatxtobj);
    Arrayobj.push(this.tableheadingfontsizeobj);
    Arrayobj.push(this.tabledatafontsizeobj);
    Arrayobj.push(this.iconbgobj);
    Arrayobj.push(this.icontxtobj);
    Arrayobj.push(this.sidebarbgobj);
    Arrayobj.push(this.sidebartxtobj);

    // console.log('default themeName', this.selectedTheme)
    let filtered = Arrayobj.filter(el => Object.keys(el).length);
    //  debugger;
    if (this.defaultThemeAray.length > 5 && this.Loggeduser.userid > 1) {
      for (let i = 0; i < filtered.length; i++) {
        filtered[i].fk_UserID = this.Loggeduser.userid;
        filtered[i].fK_CreatedById = this.Loggeduser.userid;
        filtered[i].theme = 'Custom';
      }
    }
    //  console.log('array',filtered,this.bodybgobj);
    if (this.selectedTheme == "Default") {
      // this.bodybgobj.pK_TranId = this.customeThemeAray[a].pK_TranId;
      filtered.forEach(data => {
        if (data.tag == 'body' && data.property == 'bgcolor') {
          data.pK_TranId = this.bodybgtransId;
        }
        data.isActive = false;
        //  console.log(data);
      })
      // console.log('array1',filtered,this.bodybgobj);
      let boj = {
        WebTheme: filtered
      }
      // console.log('finalobj',boj);
      this.insertthemedata(boj).subscribe(data => {
        //  console.log('api response',data)
      });

    }
    else if (this.selectedTheme == "Custom") {
      filtered.forEach(data => {
        data.isActive = true;
      })
      let boj = {
        WebTheme: filtered
      }
      // console.log('finalobj',boj);
      this.insertthemedata(boj).subscribe(data => {
        //  console.log('api response',data)
      });

    }


    this.dialog.closeAll();

  }

  // getcategories() {
  //   this.http.get<any>(this.newbaseUrl + "BillingCategoryMaster/GetCategory").
  //     subscribe(data => this.successcategories(data), err => this.failedcategories(err));
  // }
  // successcategories(data) {
  //   this.categories = data;
  // }
  // failedcategories(err) {
  // }
  getloginDynamicLinks() {
    this.themenApiunsub = this.http.get<any>(this.newbaseUrl + "Common/GetProductType").subscribe(data =>
      this.successLink(data), err => this.failedLink(err));
  }
  successLink(data) {

    this.DynamicLinks = data;

  }
  failedLink(err) {

  }
  GetCustomerInformation(customerid) {
    return this.http.get<any>(this.newbaseUrl + "Configuration/GetCustomerInformation/" + customerid)
  }
  GetUserDetailResetPassword() {
    return this.http.get<any>(this.newbaseUrl + "UserMaster/GetUserDetailResetPasswordByName/" +
      this.Loggeduser.username)
  }
  GetgenerateCaptcha() {
    return this.http.get<any>(this.newbaseUrl + "UserMaster/generate")
  }
  Getsaverole(payload: any) {
    return this.http.post<any>(this.newbaseUrl + "UserMaster/roles", payload);
  }
  aifeedbackstatus(payload:any){
     return this.http.post<any>(this.newbaseUrl + "Common/InsertAutoPrediction", payload);
   
  }
}

